'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define([], function () {

  //// See https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
  var supportsCaptureOption = false;
  function setHasSupportToCaptureOption(hasSupport) {
    supportsCaptureOption = hasSupport;
  }

  try {
    addEventListener('test', null, Object.defineProperty({}, 'capture', { get: function get() {
        setHasSupportToCaptureOption(true);
      } }));
  } catch (e) {/**/}

  function getSafeEventHandlerOpts() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

    return supportsCaptureOption ? options : options.capture;
  }
  ////

  function noop() {}

  function getPosition(event) {
    if ('touches' in event) {
      var _event$touches$ = event.touches[0],
          pageX = _event$touches$.pageX,
          pageY = _event$touches$.pageY;

      return { x: pageX, y: pageY };
    }

    var screenX = event.screenX,
        screenY = event.screenY;

    return { x: screenX, y: screenY };
  }

  var SwipeListener = function () {
    function SwipeListener(props) {
      _classCallCheck(this, SwipeListener);

      this._handleSwipeStart = this._handleSwipeStart.bind(this);
      this._handleSwipeMove = this._handleSwipeMove.bind(this);
      this._handleSwipeEnd = this._handleSwipeEnd.bind(this);

      this._onMouseDown = this._onMouseDown.bind(this);
      this._onMouseMove = this._onMouseMove.bind(this);
      this._onMouseUp = this._onMouseUp.bind(this);

      this.swiper = props.target;

      if (this.swiper) {
        this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
          capture: true,
          passive: false
        }));
        this.swiper.addEventListener('mousedown', this._onMouseDown);
        this.swiper.addEventListener('touchstart', this._handleSwipeStart);
        this.swiper.addEventListener('touchend', this._handleSwipeEnd);
      }
      this.props = props;
      props.onSwipeStart = props.onSwipeStart || noop;
      props.onSwipeMove = props.onSwipeMove || noop;
      props.onSwipeEnd = props.onSwipeEnd || noop;
      props.onSwipeLeft = props.onSwipeLeft || noop;
      props.onSwipeRight = props.onSwipeRight || noop;
      props.onSwipeUp = props.onSwipeUp || noop;
      props.onSwipeDown = props.onSwipeDown || noop;
    }

    _createClass(SwipeListener, [{
      key: '_onMouseDown',
      value: function _onMouseDown(event) {
        if (!this.props.allowMouseEvents) {
          return;
        }
        this.mouseDown = true;

        document.addEventListener('mouseup', this._onMouseUp);
        document.addEventListener('mousemove', this._onMouseMove);
        event.preventDefault();
        this._handleSwipeStart(event);
      }
    }, {
      key: '_onMouseMove',
      value: function _onMouseMove(event) {
        if (!this.mouseDown) {
          return;
        }

        this._handleSwipeMove(event);
      }
    }, {
      key: '_onMouseUp',
      value: function _onMouseUp(event) {
        this.mouseDown = false;

        document.removeEventListener('mouseup', this._onMouseUp);
        document.removeEventListener('mousemove', this._onMouseMove);

        this._handleSwipeEnd(event);
      }
    }, {
      key: '_handleSwipeStart',
      value: function _handleSwipeStart(event) {
        var _getPosition = getPosition(event),
            x = _getPosition.x,
            y = _getPosition.y;

        this.moveStart = { x: x, y: y };
        this.props.onSwipeStart(event, this.moveStart);
      }
    }, {
      key: '_handleSwipeMove',
      value: function _handleSwipeMove(event) {
        if (!this.moveStart) {
          return;
        }

        var _getPosition2 = getPosition(event),
            x = _getPosition2.x,
            y = _getPosition2.y;

        var deltaX = x - this.moveStart.x;
        var deltaY = y - this.moveStart.y;
        this.moving = true;

        // hand the responsibility of cancelling the scroll to
        // the component handling the event
        var shouldPreventDefault = this.props.onSwipeMove({
          x: deltaX,
          y: deltaY
        }, event);

        if (shouldPreventDefault) {
          event.preventDefault();
        }

        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
      }
    }, {
      key: '_handleSwipeEnd',
      value: function _handleSwipeEnd(event) {
        this.props.onSwipeEnd(event);

        var tolerance = this.props.tolerance;


        if (this.moving && this.movePosition) {
          if (this.movePosition.deltaX < -tolerance) {
            this.props.onSwipeLeft(event);
          } else if (this.movePosition.deltaX > tolerance) {
            this.props.onSwipeRight(event);
          }
          if (this.movePosition.deltaY < -tolerance) {
            this.props.onSwipeUp(event);
          } else if (this.movePosition.deltaY > tolerance) {
            this.props.onSwipeDown(event);
          }
        }

        this.moveStart = null;
        this.moving = false;
        this.movePosition = null;
      }
    }]);

    return SwipeListener;
  }();

  return SwipeListener;
});
//# sourceMappingURL=swipe-listener.js.map
